<div class="group mt-3 mb-3">
	<app-text-input
		class="block mb-3"
		label="Target X (%)"
		i18n-label="Target X Label@@imageToolCropTargetXLabel"
		[currentValue]="form.value.target.x"
		(valueChange)="form.patchValue({ target: { x: $event } })"
	></app-text-input>

	<app-text-input
		class="block mb-3"
		label="Target Y (%)"
		i18n-label="Target Y Label@@imageToolCropTargetYLabel"
		[currentValue]="form.value.target.y"
		(valueChange)="form.patchValue({ target: { y: $event } })"
	></app-text-input>

	<app-text-input
		class="block mb-3"
		label="Target Width (%)"
		i18n-label="Target Width Label@@imageToolCropTargetWidthLabel"
		[currentValue]="form.value.target.width"
		(valueChange)="form.patchValue({ target: { width: $event } })"
	></app-text-input>

	<app-text-input
		class="block mb-3"
		label="Target Height (%)"
		i18n-label="Target Height Label@@imageToolCropTargetHeightLabel"
		[currentValue]="form.value.target.height"
		(valueChange)="form.patchValue({ target: { height: $event } })"
	></app-text-input>
</div>

<div class="group" *ngIf="isAtLeastAdmin || isEditor">
	<h3>Editor Settings</h3>

	<!-- Copy Settings -->
	<button
		mat-flat-button
		color="primary"
		class="block mb-3"
		[disabled]="!form.value.target"
		(click)="copySettings()"
	>
		Copy Crop Data
	</button>

	<!-- Thumbnail: Only show in editor mode -->
	<ng-container *ngIf="isEditor">
		<app-textarea-input
			class="block mb-3"
			label="Replace Image with URL"
			i18n-label="Replace Image with URL@@imageToolCropReplaceImageWithUrlLabel"
			[currentValue]="activeAsset?.assetPath"
			(valueChange)="activeAssetChange.emit({ assetPath: $event })"
		></app-textarea-input>
	</ng-container>


</div>
